import { create } from 'zustand';

interface CapacitorUpdateState {
  isOpen: boolean;
  pendingBundleId: string | null;
  pendingVersion: string | null;
  showUpdate: (bundleId: string, version: string) => void;
  dismiss: () => void;
  clear: () => void;
}

export const useCapacitorUpdateStore = create<CapacitorUpdateState>((set) => ({
  isOpen: false,
  pendingBundleId: null,
  pendingVersion: null,
  showUpdate: (bundleId, version) =>
    set({ isOpen: true, pendingBundleId: bundleId, pendingVersion: version }),
  dismiss: () => set({ isOpen: false }),
  clear: () =>
    set({ isOpen: false, pendingBundleId: null, pendingVersion: null }),
}));